import { Card, CardContent, CardFooter, CardTitle } from "@ui/card";
import { msToHoursBalance } from "@utils/helpers/timeFormtter";

import { SVG } from "../common/SVG";
import { ProgressBar } from "./ShadcnProgressBar";
import TranslatedText from "./TranslatedText";

interface SkillCardProps {
  image: string;
  icon: string;
  title: string;
  discription: string;
  progress: number;
  isStarted?: boolean;
  completedSummaries: number;
  totalSummaries: number;
  totalDuration: number;
  onCardClick?: () => void;
  onSartClick?: () => void;
}

const SkillCard = ({
  image,
  icon,
  title,
  discription,
  progress,
  isStarted = false,
  completedSummaries,
  totalSummaries,
  totalDuration,
  onCardClick,
  onSartClick,
}: SkillCardProps) => {
  return (
    <Card
      className="h-[290px] w-[215px] cursor-pointer overflow-hidden rounded-xl border-none bg-transparent"
      onClick={onCardClick}
    >
      <CardContent className="relative w-full p-0">
        <img src={image} alt={title} width={250} height={200} />
        <img
          src={icon}
          alt={title}
          className="absolute left-1/2 top-1/2 h-[80px] w-[80px] -translate-x-1/2 -translate-y-1/2"
        />
      </CardContent>
      <div className="pt-[5%]">
        <CardTitle className="space-y-1">
          <div className="grid grid-cols-12 items-center justify-center gap-x-2 px-2">
            <div className="col-span-9">
              <ProgressBar
                value={progress}
                prgresserBg="bg-navy-blue"
                height="h-[5px]"
                bgStyle="bg-[#B5B5B5]/20"
              />
            </div>
            <div className="col-span-3 flex justify-center text-[13px] font-normal dark:text-white">
              {`${progress} %`}
            </div>
          </div>
          <div className="p-2 pt-0 text-[20px] text-navy-blue dark:text-white">
            {title}
          </div>
        </CardTitle>
        <CardFooter className="flex flex-col px-2 pb-0 dark:text-white">
          <div className="text-[12px] ltr:text-left rtl:text-right">
            {discription}
          </div>
          <div className="flex w-full items-center justify-start gap-x-12 py-2 text-[11px]">
            <div className="flex items-center gap-x-1">
              <div className="flex items-center ltr:hidden">
                <p>{totalSummaries}</p>/ <p>{completedSummaries}</p>
              </div>
              <div className="flex items-center rtl:hidden">
                <p>{completedSummaries}</p>/ <p>{totalSummaries}</p>
              </div>
              <TranslatedText text={`home.skill-card.${"summary"}`} />
            </div>
            <div>{msToHoursBalance(totalDuration)}</div>
          </div>
          {!isStarted && (
            <div
              className="flex w-full items-center justify-start gap-x-1 pb-2 text-[12px] hover:opacity-80"
              onClick={onSartClick}
            >
              <div className="flex h-[28px] w-[28px] items-center justify-center rounded-full bg-[#1F2F63]">
                <SVG src="/assets/icons/arrow.svg" className="ltr:rotate-180" />
              </div>
              <TranslatedText text={`home.skill-card.${"start-now"}`} />
            </div>
          )}
        </CardFooter>
      </div>
    </Card>
  );
};

export default SkillCard;
